export const contingentSearchIconIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" fill="none"><path d="M24.667 24.667L20 20M10.667 20a9.333 9.333 0 100-18.667 9.333 9.333 0 000 18.667z" stroke="#8EABB8" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square"/><path d="M6 10.667A4.667 4.667 0 0110.667 6" stroke="#8EABB8" stroke-width="1.5" stroke-miterlimit="10"/></svg>`,
  name: 'search-icon',
};
